import { createSlice } from '@reduxjs/toolkit';

import initialState from './initialState';
import { STATUS_TYPES } from '../../constants';

const metadataSlice = createSlice({
  name: 'metadata',
  initialState,
  reducers: {
    metadataFetching(state) {
      state.status = STATUS_TYPES.INIT_STATE;
    },
    metadataSucceeded(state, { payload }) {
      state.status = STATUS_TYPES.SUCCEED_STATE;
      state.data = payload;
    },
    metadataFailed(state, { payload }) {
      state.status = STATUS_TYPES.FAILED_STATE;
      state.error = {
        status: payload?.status,
        message: payload?.message,
      };
    },
    clearMetadata() {
      return initialState;
    },
  },
});

export const {
  metadataFetching,
  metadataSucceeded,
  metadataFailed,
  clearMetadata,
} = metadataSlice.actions;

export default metadataSlice.reducer;
